<template>
  <div class="minicart">
    <MButton primary bold @click="$router.push(`/${storeUrl}/cart`)">
      <i class="iconfont dm-a-Shoppingbag" />
      <span class="text">{{ $t('list.toCart') }}</span>
      <span class="count">{{ cartData.totalQuantity }}</span>
    </MButton>
  </div>
</template>

<script>
import MButton from 'src/components/MButton';

export default {
  components: { MButton },
  props: {
    cartData: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style lang="scss" scoped>
.minicart {
  position: absolute;
  bottom: 20px;
  width: 85%;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  .text {
    padding: 0 8px;
  }
  .count {
    display: inline-block;
    background: #ffffff;
    color: $black;
    height: 20px;
    line-height: 20px;
    min-width: 20px;
    font-size: 16px;
    border-radius: 10px;
    text-align: center;
    padding: 0 4px;
  }
  :deep(.mbtn) {
    width: 100%;
    .mbtn-core {
      display: flex;
      align-items: center;
    }
  }
}
</style>
